import { useEffect } from "react";
import { listenPersonaSwitch } from "@/lib/authv2/persona";

/** Thẻ khác đổi danh phận ⇒ thẻ này tải lại (QĐ 0255). Gắn một lần ở khung trang. */
export function usePersonaSync(): void {
  useEffect(() => listenPersonaSwitch(), []);
}
